import { Route, Switch, Redirect } from 'react-router-dom';

import { PublicMainPage } from 'PublicMainPackage/MainModule/components/PublicMainPage';
import { PublicFeedback } from 'FeedbackPackage/MainModule/components/PublicFeedback';
import { News } from 'NewsPackage/MainModule/components/News';
import { SystemInoperability } from 'NewsPackage/MainModule/components/SystemInoperability';
import { ChecksData } from 'OpenDataPackage/MainModule/components/ChecksData';
import { OpenData } from 'OpenDataPackage/MainModule/components/OpenData';
import { PassportKnm } from 'PassportKnmPackage/MainModule/components/PassportKnm';
import { Search } from 'SearchPackage/MainModule/components/Search';
import { PassportDecision } from 'PassportKnmPackage/MainModule/components/Decision/PassportDecision';
import { PublickExtractPage } from 'PublickExtractPackage/MainModule/components/PublickExtractPage';

import {
  ROUTE_FEEDBACK,
  ROUTE_INDEX,
  ROUTE_KNM_BY_ID,
  ROUTE_KNM_BY_QR_CODE,
  ROUTE_NEWS,
  ROUTE_SYSTEM_INOPERABILITY,
  ROUTE_OPEN_DATA,
  ROUTE_OPEN_DATA_BY_YEAR,
  ROUTE_PORTAL,
  ROUTE_SEARCH,
  ROUTE_DECISION_BY_ID,
  ROUTE_DECISION_BY_QR_CODE,
  ROUTE_KNM_BY_NONEXISTENT_QR_CODE,
  ROUTE_PM_BY_NONEXISTENT_QR_CODE,
  ROUTE_PUBLIC_EXTRACT,
} from '../constants/routes';

export const App = () => (
  <div className="app">
    <Switch>
      <Route exact path={ROUTE_PORTAL} component={PublicMainPage} />
      <Route exact path={ROUTE_OPEN_DATA} component={OpenData} />
      <Route exact path={ROUTE_SEARCH} component={Search} />
      <Route exact path={ROUTE_NEWS} component={News} />
      <Route exact path={ROUTE_SYSTEM_INOPERABILITY} component={SystemInoperability} />
      <Route exact path={ROUTE_FEEDBACK} component={PublicFeedback} />
      <Route exact path={ROUTE_OPEN_DATA_BY_YEAR} component={ChecksData} />
      <Route exact path={ROUTE_KNM_BY_ID} component={PassportKnm} />
      <Route exact path={ROUTE_KNM_BY_QR_CODE} component={PassportKnm} />
      <Route exact path={ROUTE_DECISION_BY_ID} component={PassportDecision} />
      <Route exact path={ROUTE_DECISION_BY_QR_CODE} component={PassportDecision} />
      <Route exact path={ROUTE_KNM_BY_NONEXISTENT_QR_CODE} component={PublicMainPage} />
      <Route exact path={ROUTE_PM_BY_NONEXISTENT_QR_CODE} component={PublicMainPage} />
      <Route exact path={ROUTE_PUBLIC_EXTRACT} component={PublickExtractPage} />
      <Redirect from={ROUTE_INDEX} to={ROUTE_PORTAL} />
    </Switch>
  </div>
);
